import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { HeaderModule } from '../modules/header/header.module';
import { FooterModule } from '../modules/footer/footer.module';
import { ArticleListItemModule } from '../modules/article-list-item/article-list-item.module';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { PageLoaderModule } from '../modules/page-loader/page-loader.module';

@NgModule({
    declarations: [
        AppComponent,

        HeaderModule,
        FooterModule,
        ArticleListItemModule,
        PageLoaderModule
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        FontAwesomeModule
    ],
    providers: [
        Location,
        {
            provide : LocationStrategy,
            useClass: HashLocationStrategy
        }
    ],
    bootstrap: [
        AppComponent
    ]
})
export class AppModule { }
